import { logger } from "./logger.js";
import type { TelegramWebApp } from "./telegram-types.js";

/**
 * Returns the Telegram WebApp instance if the script loaded and we're
 * actually inside Telegram, otherwise null.
 *
 * Outside Telegram (regular browser dev), `window.Telegram.WebApp` is
 * still injected by `telegram-web-app.js` but `initData` is empty —
 * use that as the "really inside Telegram?" signal.
 */
export function getWebApp(): TelegramWebApp | null {
  if (typeof window === "undefined") return null;
  const wa = window.Telegram?.WebApp;
  if (!wa) return null;
  return wa;
}

export function isInsideTelegram(): boolean {
  const wa = getWebApp();
  if (!wa) return false;
  return wa.initData.length > 0;
}

export function bootstrapWebApp(): TelegramWebApp | null {
  const wa = getWebApp();
  if (!wa) {
    logger.warn(
      "telegram-web-app.js did not load; running in non-Telegram mode",
    );
    return null;
  }

  try {
    wa.ready();
    wa.expand();

    const bg = wa.themeParams.bg_color ?? "#ffffff";
    if (typeof wa.setBackgroundColor === "function") {
      wa.setBackgroundColor(bg);
    }
    if (typeof wa.setHeaderColor === "function") {
      wa.setHeaderColor("bg_color");
    }
  } catch (err) {
    logger.error("WebApp bootstrap failed", err);
  }

  return wa;
}
